import Button from "atoms/buttons/button";
import { ButtonStyles } from "atoms/constants/button-styles";
import Paragraph from "atoms/typography/paragraph";
import React, { useState } from "react";
import { AppNameTm } from "constants/app-name-tm";
import Trans from "atoms/i18n/trans";
import Anchor from "atoms/anchors/anchor";
import { AnchorTargetTypes } from "@rsm-hcd/javascript-core";
import useNfpaUrlPaths from "utilities/hooks/use-nfpa-url-paths";
import { siteMap } from "internal-sitemap";
import { t } from "utilities/localization-utils";
import { SupportConstants } from "constants/phone-number-constants";
import EcommerceRedirectionModal from "organisms/subscription-card/ecommerce-redirection-modal";

interface SubscriptionExpiredBannerProps {
    userIsEnterpriseAdmin: boolean;
    subscriptionPin: string;
}

const CSS_BASE_CLASS = "c-account-subscription-info-banner";

const SubscriptionExpiredBanner = (props: SubscriptionExpiredBannerProps) => {
    const { accountPayments } = useNfpaUrlPaths();
    const { userIsEnterpriseAdmin, subscriptionPin } = props;
    const [redirecting, setRedirecting] = useState(false);

    const handleOnClick = userIsEnterpriseAdmin
        ? () =>
              window.open(
                  `mailto:${SupportConstants.CustomerServiceEmail}?subject=${encodeURIComponent("COD Support Request")}`,
                  "_blank"
              )
        : () => setRedirecting(true);

    return (
        <div className={`${CSS_BASE_CLASS} -expired`}>
            <div className={`${CSS_BASE_CLASS}__content`}>
                <Paragraph cssClassName={`${CSS_BASE_CLASS}__title`}>
                    {t("plansPage-subscriptionExpired-title", {
                        appName: AppNameTm,
                    })}
                </Paragraph>
                <Paragraph cssClassName={`${CSS_BASE_CLASS}__description`}>
                    <Trans
                        i18nKey="warning-subscriptionHasExpired-description"
                        components={{
                            anchor1: (
                                <Anchor
                                    ariaLabel={"Update your payment method"}
                                    external={true}
                                    target={AnchorTargetTypes.Blank}
                                    to={accountPayments}>
                                    update your payment method{" "}
                                </Anchor>
                            ),
                            anchor2: (
                                <Anchor
                                    to={`${siteMap.support.faq}#payment-info`}>
                                    {" "}
                                    contact customer support
                                </Anchor>
                            ),
                        }}></Trans>
                </Paragraph>
            </div>
            <Button
                onClick={handleOnClick}
                cssClassName={`${CSS_BASE_CLASS}__button`}
                style={ButtonStyles.Primary}>
                {t("warning-subscriptionHasExpired-buttonText")}
            </Button>
            {redirecting && (
                <EcommerceRedirectionModal
                    pin={subscriptionPin}
                    withPurchaseText={false}
                />
            )}
        </div>
    );
};

export default SubscriptionExpiredBanner;
